import React from "react";
import "./about.css";

const About = () => {
  return (
    <div className="main_aboutUs">
      <div className="container_about">
        <p>
          <div className="text_rainbow">
            <h1>Nails by Vera</h1>
          </div>
          Üdvözöljük a Nails by Vera körömszalonban, Szentendre büszkeségében,
          ahol a város legjobb manikűr és pedikűr szolgáltatásait kínáljuk!
          Profi csapatunk készen áll, hogy felejthetetlen élményt nyújtson
          Önnek.
        </p>
        <p>
          Széles köröm kezelési választékunk garantálja az egészséges és szép
          körmöket. Akár klasszikus manikűrre, akár gyors körömkezelésre vágyik,
          professzionális eredményekre számíthat, ha a hagyományos
          szolgáltatásainkat választja.
        </p>
        <p>
          Célunk, hogy segítsünk ötleteket megvalósítani és megtaláljuk az Ön
          igényeinek legmegfelelőbb megoldást. Látogasson el hozzánk, és
          pihenjen egy kényelmes, kellemes légkörben, miközben körmeit
          elkészítjük. Szentendre legjobb köröm szalonjában garantáltan örömet
          fog lelni. Engedje meg, hogy kényeztessük, és távozáskor mosoly legyen
          az arcán.
        </p>
        <p>
          Az időpont foglalása egyszerű és gyors, így ne habozzon kapcsolatba
          lépni velünk, hogy azonnal időpontot foglaljon!
        </p>
      </div>
    </div>
  );
};

export default About;
